export const GetAppRootUrl = () => window.location.origin;

export const GetCurrentUrl = () => window.location.origin + window.location.pathname;
